export enum CubeSchemaNames {
  APP = 'App',
  ANALYTICS_ACTIVITY_FEED_ITEM = 'AnalyticsActivityFeedItem',
  ANALYTICS_ACTIVITY_V2 = 'AnalyticsActivityV2',
  TEAM_ANALYTICS_ACTIVITY_V2 = 'TeamAnalyticsActivityV2',
  WORKING_DAYS_ANALYTICS_ACTIVITY_V2 = 'WorkingDaysAnalyticsActivityV2',
  WORKING_SESSIONS_ANALYTICS_ACTIVITY_V2 = 'WorkingSessionsAnalyticsActivityV2',
  SENTIMENT_REPORT = 'SentimentReport',
  ANALYTICS_EVENT = 'AnalyticsEvent',
  ANALYTICS_TEAM_EVENT_ITEM = 'AnalyticsTeamEventItem',
  ANALYTICS_USER = 'AnalyticsUser',
  ORGANIZATION_ANALYTICS_EVENT = 'OrgAnalyticsEvent',
  ORGANIZATION_WORKING_DAYS_ANALYTICS_ACTIVITY = 'OrgWorkingDaysActivity',
  ORGANIZATION_WORKING_SESSIONS_ANALYTICS_ACTIVITY = 'OrgWorkingSessionsActivity',
}
